import React from "react";
import { useTranslation } from "react-i18next";

import { BusinessDayWorkingHoursContainer, Text } from "./BusinessDayWorkingHours.styles";

export interface BusinessDayWorkingHoursProps {
  dayOfWeek: number;
  startTime: string;
  endTime: string;
}

const BusinessDayWorkingHours: React.FC<BusinessDayWorkingHoursProps> = ({ dayOfWeek, startTime, endTime }) => {
  const { i18n } = useTranslation();

  const dayOfWeekName = new Intl.DateTimeFormat(i18n.language, {
    weekday: "long",
  }).format(new Date(0, 0, dayOfWeek));

  const isCurrentDay = new Date().getDay() === dayOfWeek;

  return (
    <BusinessDayWorkingHoursContainer data-current={isCurrentDay}>
      <Text strong={isCurrentDay}>{dayOfWeekName}</Text>
      <Text strong={isCurrentDay}>
        {startTime} - {endTime}
      </Text>
    </BusinessDayWorkingHoursContainer>
  );
};

export default BusinessDayWorkingHours;
